import React from 'react';
import { Mail, Phone, Facebook, Instagram } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-50 py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-light tracking-wider underline" style={{ fontFamily: 'Arial, sans-serif' }}>
              BERNARD FAN CO.
            </h3>
            <p className="text-stone-400 leading-relaxed">
              Luxury fans where timeless design meets whisper-quiet performance.
            </p>
            <div className="flex items-center space-x-4">
              <a
                href="https://www.facebook.com/p/Bernard-Fan-Co-100064763676607/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <Facebook size={30} className="text-[#1877F2]" />
              </a>
              <a
                href="https://www.instagram.com/bernardfanco/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity duration-200"
              >
                <Instagram size={30} className="text-[#E4405F]" />
              </a>
            </div>
          </div>
          
          <div className="space-y-6">
            <h4 className="text-sm tracking-widest text-stone-400 uppercase">
              Quick Links
            </h4>
            <nav className="grid grid-cols-2 gap-x-8 gap-y-3">
              <a
                href="/"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Home
              </a>
              <a
                href="/collection/oversized-fans"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Oversized Fans
              </a>
              <a
                href="/collection/ceiling-fans"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Ceiling Fans
              </a>
              <a
                href="/collection/wall-fans"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Wall Fans
              </a>
              <a
                href="/collection/light-fans"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Light Fans
              </a>
              <a
                href="/collection/multi-purpose-fans"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Multi Purpose Fans
              </a>
              <a
                href="/display-centres"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Showrooms
              </a>
              <a
                href="/faqs"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                FAQs
              </a>
              <a
                href="/contact-us"
                className="text-stone-300 hover:text-stone-50 text-left transition-colors duration-200"
              >
                Contact Us
              </a>
            </nav>
          </div>
          
          <div className="space-y-6">
            <h4 className="text-sm tracking-widest text-stone-400 uppercase">
              Contact
            </h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <Mail className="text-stone-400 mt-1" size={18} />
                <span className="text-stone-300">contact@bernardfancopk.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="text-stone-400 mt-1" size={18} />
                <span className="text-stone-300">+923072222302</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-stone-800 pt-8 text-center">
          <p className="text-stone-400 text-sm">
            © 2013 Bernard Fan Co. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};